(function() {
  if (customElements.get('ap-product-showcase')) return;

  class ProductShowcase extends HTMLElement {
    connectedCallback() {
      this.slideshows = {};
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-showcase-panel]'));
      if (!this.panels.length) return;

      this.buildTabs();

      var active = this.panels.filter(function(p) {
        return p.classList.contains('is-active');
      })[0] || this.panels[0];
      this.activate(active.dataset.blockId);

      this._onBreakpointChange = this.reflow.bind(this);
      document.addEventListener('matchSmall', this._onBreakpointChange);
      document.addEventListener('unmatchSmall', this._onBreakpointChange);

      if (window.Shopify && window.Shopify.designMode) {
        this._onBlockSelect = this.handleBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('matchSmall', this._onBreakpointChange);
      document.removeEventListener('unmatchSmall', this._onBreakpointChange);
      if (this._onBlockSelect) {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }
      this.destroySlideshows();
    }

    // Tab labels come from each panel's data-tab-title (theme blocks don't
    // expose their settings to the section's Liquid), so the buttons are
    // rendered client-side.
    buildTabs() {
      this.tabs = [];
      var tablist = this.querySelector('[data-showcase-tablist]');
      if (!tablist) return;

      tablist.innerHTML = '';
      this.panels.forEach(function(panel, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ap-product-showcase__tab';
        btn.id = 'ShowcaseTab-' + panel.dataset.blockId;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-controls', 'ShowcasePanel-' + panel.dataset.blockId);
        btn.dataset.tabTarget = panel.dataset.blockId;
        btn.textContent = panel.dataset.tabTitle || 'Tab ' + (index + 1);
        btn.addEventListener('click', function() {
          this.activate(panel.dataset.blockId);
        }.bind(this));
        tablist.appendChild(btn);
        this.tabs.push(btn);
      }, this);
    }

    destroySlideshows() {
      for (var id in this.slideshows) {
        if (this.slideshows[id]) this.slideshows[id].destroy();
      }
      this.slideshows = {};
    }

    perRow() {
      var small = window.theme && theme.config && theme.config.bpSmall;
      var value = small ? this.dataset.perRowMobile : this.dataset.perRow;
      return parseFloat(value) || 1;
    }

    activePanel() {
      return this.panels.filter(function(p) {
        return p.classList.contains('is-active');
      })[0];
    }

    activate(blockId) {
      this.tabs.forEach(function(tab) {
        var isActive = tab.dataset.tabTarget === blockId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var panel;
      this.panels.forEach(function(p) {
        var isActive = p.dataset.blockId === blockId;
        p.classList.toggle('is-active', isActive);
        if (isActive) panel = p;
      });

      if (!panel) return;
      requestAnimationFrame(this.initPanel.bind(this, panel));
    }

    initPanel(panel) {
      var id = panel.dataset.blockId;
      if (this.slideshows[id]) {
        this.slideshows[id].resize();
        return;
      }

      var slider = panel.querySelector('[data-showcase-slider]');
      if (!slider) return;
      if (slider.children.length <= this.perRow()) {
        slider.classList.add('ap-product-showcase__slider--static');
        return;
      }
      slider.classList.remove('ap-product-showcase__slider--static');
      if (!window.theme || !theme.Slideshow) return;

      this.slideshows[id] = new theme.Slideshow(slider, {
        prevNextButtons: this.dataset.arrows === 'true',
        pageDots: this.dataset.dots === 'true',
        groupCells: true,
        wrapAround: false,
        adaptiveHeight: false,
        contain: true,
        cellAlign: 'left',
        dragThreshold: 10
      });
    }

    reflow() {
      this.destroySlideshows();
      var panel = this.activePanel();
      if (panel) requestAnimationFrame(this.initPanel.bind(this, panel));
    }

    handleBlockSelect(evt) {
      if (!this.contains(evt.target)) return;

      var panel = evt.target.closest('[data-showcase-panel]');
      if (!panel) return;
      this.activate(panel.dataset.blockId);

      var item = evt.target.closest('.ap-product-showcase__item');
      var slideshow = this.slideshows[panel.dataset.blockId];
      if (item && slideshow && slideshow.slideshow) {
        // The Flickity cell is the Shopify block wrapper around the item
        var cell = item;
        while (
          cell.parentElement &&
          !cell.parentElement.classList.contains('flickity-slider') &&
          !cell.parentElement.hasAttribute('data-showcase-slider')
        ) {
          cell = cell.parentElement;
        }
        slideshow.slideshow.selectCell(cell);
      }
    }
  }

  customElements.define('ap-product-showcase', ProductShowcase);
})();
